export enum EnumStatus {
    Pendente = "P",
    Iniciado = "I",
    Solicitado = "S",
    Finalizado = "F",
    Cancelado = "C",
}
